class ReadMoreDescription extends HTMLElement {
  constructor() {
    super()

    this.btn = this.querySelector('.btn-description')
    this.short = this.querySelector('.short-description')
    this.full = this.querySelector('.full-description')
    this.initialiseReadMoreDescription()
    
  }

  initialiseReadMoreDescription() {
    this.btn.addEventListener('click', () => {
      this.short.classList.toggle('short-description--open')
      this.full.classList.toggle('full-description--open')
      if (this.btn.innerHTML === 'Read Less') {
        this.btn.innerHTML = 'Read More'
      } else {
        this.btn.innerHTML = 'Read Less'
      }
    })  
  }

}

customElements.define('read-more-description', ReadMoreDescription)